import { type ApiResponse, ApiFactory } from '@/utils/api'
import { StoreEnums } from '@/constants/enums/api/store.enums'
import type {
  UpdateStoreMetricThresholdRequest,
  GetStoreMetricThresholdResponse
} from '@/models/types/storeMetricThreshold.types'

/**
 * 店家指標門檻設定 API Service
 *
 * 提供取得與更新店家層級的閒置時間/低營業額/負毛利門檻設定。
 */
export class StoreMetricThresholdService extends ApiFactory {
  constructor() {
    super('')
  }

  /**
   * 取得店家當前指標門檻設定
   */
  getStoreMetricThreshold = async (): Promise<ApiResponse<GetStoreMetricThresholdResponse>> => {
    return await this.get<unknown, ApiResponse<GetStoreMetricThresholdResponse>>(
      StoreEnums.storeMetricThreshold
    )
  }

  /**
   * 更新店家指標門檻設定
   */
  updateStoreMetricThreshold = async (
    params: UpdateStoreMetricThresholdRequest
  ): Promise<ApiResponse> => {
    return await this.put<UpdateStoreMetricThresholdRequest, ApiResponse>(
      StoreEnums.storeMetricThreshold,
      params
    )
  }
}
